module.exports = "/fonts/feather.svg?0323f615a5436b8297699d7cc3714319";